import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdatePremierCredentialsComponent } from './update-premier-credentials.component';
import { AppMaterialModule } from 'src/app/app-material/app-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [UpdatePremierCredentialsComponent],
  imports: [
    AppMaterialModule,
    ReactiveFormsModule,
    CommonModule,
    MatCheckboxModule,
    FormsModule
  ]
})
export class UpdatePremierCredentialsModule {}
